import _ from 'lodash';
import Injector from 'vue-inject';
import Debug from '@/util/debug';

const debug = Debug('service:GoalType');

export const GOAL_REACH_FREQUENCY = 'reach_frequency';
export const GOAL_REACH_AND_CLICK = 'reach_and_click';
export const GOAL_LEAD_GENERATION = 'lead_generation';
export const GOAL_LOCAL_OFFERS = 'local_offers';
export const GOAL_POST_ENGAGEMENT = 'post_engagement';

export default class GoalTypeService {
  constructor(genericConfigService) {
    this.genericConfigService = genericConfigService;
    this.options = [];
  }

  getOptions() {
    debug.info('getOptions', this.options);

    return this.genericConfigService.getConfig()
      .then(config => Object.assign({}, this.options, config.goal_types))
      .catch(err => { debug.error('error: %o', err); throw err; });
  }

  getDefault() {
    return this.getOptions()
      .then(options => {
        if (Object.values(options).length) {
          const obj = Object.values(options).map((t, v) => ({
            ...t,
            goal_type: Object.keys(options)[v],
          }));
          return obj[0];
        }

        throw new Error('no goal_type options');
      });
  }

  getLeadConfig() {
    return this.genericConfigService.getConfig()
      .then(config => _.get(config, `goal_types.${GOAL_LEAD_GENERATION}.config`, null))
      .catch(err => { debug.error('error: %o', err); throw err; });
  }
}

Injector.service('goalTypeService', ['genericConfigService'], GoalTypeService);



// WEBPACK FOOTER //
// ./src/services/GoalTypeService.js